// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"043c25b7","416":"a4ab9498","588":"3d43d2e9","944":"30b5f365"}[chunkId] + ".chunk.js";
};